// Authentication
export const SET_USER = 'SET_USER'

// Dialog
export const SHOW_ALERT = 'SHOW_ALERT'

// Estates
export const LOAD_ESTATES = 'LOAD_ESTATES'